const quizClassMap = new Map();
import { NumberMultipleChoiceQuiz } from "./numberMultipleChoiceQuiz";
quizClassMap.set("NumberMultipleChoiceQuiz", NumberMultipleChoiceQuiz);
import { TextMultipleChoiceQuiz } from "./textMultipleChoiceQuiz";
quizClassMap.set("TextMultipleChoiceQuiz", TextMultipleChoiceQuiz);
function createQuiz(isRandomize, multipleChoiceQuizData) {
    const quizClass = quizClassMap.get(multipleChoiceQuizData.className);
    if (quizClass != null) {
        return new quizClass(isRandomize, multipleChoiceQuizData.parameterData);
    }
    else {
        throw new Error("Could not find Quiz Class : " + multipleChoiceQuizData.className);
    }
}
function createQuizs(isRandomize, multipleChoiceQuizDatas) {
    const multipleChoiceQuizs = new Array();
    for (const multipleChoiceQuizData of multipleChoiceQuizDatas) {
        multipleChoiceQuizs.push(createQuiz(isRandomize, multipleChoiceQuizData));
    }
    return multipleChoiceQuizs;
}
export { createQuizs, createQuiz };
